import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loader from '../../components/loader';
import AssetConfig from '../../components/assetconfig';

const qs = require('query-string');

class HistoryInitial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enabledPairs: '',
      enabledAssets: '',
      initialState: '',
    };
    this.getPairAssets = this.getPairAssets.bind(this);
    this.pairsInitial = this.pairsInitial.bind(this);
    // this.stateSetup = this.stateSetup.bind(this);
    this.showPair = this.showPair.bind(this);
    this.showAsset = this.showAsset.bind(this);
  }

  componentDidMount() {
    const { assets, pairs } = this.props;
    this.assetsInitial();
    this.pairsInitial();
  }

  getPairAssets(pair) {
    const { pairs } = this.props;
    let altPair;
    let pairAssets;
    let useAssets;
    if (pairs && Object.keys(pairs).length) {
      if (pairs[pair] && pairs[pair].alt) {
        altPair = pairs[pair].alt;
      }
    }
    if (altPair) {
      pairAssets = altPair.split(':');
    }
    if (pairAssets && pairAssets.length && pairAssets[0] && pairAssets[1]) {
      useAssets = {
        exchA: pairAssets[0],
        exchB: pairAssets[1],
      };
    }
    return useAssets;
  }

  assetsInitial() {
    const { assets, pairs } = this.props;
    let allAssets;
    let enabledAssets;
    if (assets && assets.length) {
      allAssets = assets && assets.map((item) => {
        return (item.handle);
      });
    }
    if (allAssets && allAssets.length) {
      enabledAssets = allAssets.filter((item) => this.showAsset(item));
    }
    this.setState({
      enabledAssets,
    });
  }

  pairsInitial() {
    const { assets, pairs } = this.props;
    const limitPairs = {};
    if (pairs && Object.keys(pairs).length) {
      Object.keys(pairs).forEach((key) => {
        if (pairs[key] && pairs[key].permissions) {
          if (pairs[key].permissions.includes('LIMIT') || pairs[key].permissions.includes('OTC')) {
            limitPairs[key] = pairs[key];
          }
        }
      });
    }
    const enabledAssets = [];
    if ((AssetConfig && AssetConfig.length)) {
      AssetConfig.map((asset) => {
        if (asset.enabled) {
          enabledAssets.push(asset.handle);
        }
      });
    }
    const enabledPairs = [];
    if (limitPairs && Object.keys(limitPairs).length) {
      Object.keys(limitPairs).forEach((key) => {
        if (limitPairs[key] && limitPairs[key].alt) {
          const pairAssets = limitPairs[key].alt.split(':');

          let isEnabled;
          if (pairAssets && pairAssets.length) {
            isEnabled = pairAssets.every((asset) => enabledAssets.includes(asset));
          }
          if (isEnabled) {
            enabledPairs.push(key);
          }
        }
      });
    }
    this.setState({
      enabledPairs,
    });
  }

  showPair(pair, directPairs) {
    const { enabledPairs } = this.state;
    let enabled;
    if (enabledPairs) {
      enabled = enabledPairs;
    }
    if (directPairs) {
      enabled = directPairs;
    }
    let pairEnabled;
    if (enabled && pair) {
      pairEnabled = enabled.includes(pair);
    }
    return pairEnabled;
  }

  showAsset(asset) {
    let assetConf;
    if (AssetConfig && AssetConfig.length) {
      assetConf = AssetConfig.find((item) => item.handle === asset.toUpperCase());
    }
    // let assetEnabled;
    // if (assetConf && assetConf.enabled) {
    //   assetEnabled = assetConf.enabled;
    // }
    let historyEnabled;
    if (assetConf && assetConf.showHistory) {
      historyEnabled = assetConf.showHistory;
    }
    return historyEnabled;
  }

  render() {
    const { assets, pairs, location, history } = this.props;
    const { enabledPairs, enabledAssets } = this.state;

    const tradeReady = (pairs && Object.keys(pairs).length) && (assets && assets.length) && (enabledPairs && enabledAssets);

    if (tradeReady) {
      return (
        React.cloneElement(this.props.children, {
          enabledPairs,
          enabledAssets,
          location,
          history,
          getPairAssets: this.getPairAssets,
          showPair: this.showPair,
          showAsset: this.showAsset,
        })
      );
    }
    return (
      <div>
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="center-loader">
              <Loader logo />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
});

export default withRouter(connect(mapStateToProps)(HistoryInitial));
